import { Heading } from '@hover/blueprint';
import React from 'react';

interface HeaderProps {
  header: React.ReactNode;
  paddingX: { base: number; tablet: number };
}

export const Header = ({ header, paddingX }: HeaderProps) => (
  <Heading as="h1" noMargin px={paddingX} size={{ base: 500, tablet: 600 }}>
    {header}
  </Heading>
);
